import { useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { MessageContext } from '@/helpers/MessageProvider';

const useVideoCommand = () => {
  const { publishCommand } = useContext(MessageContext);

  const changeLens = (videoType) => (robot) => {
    const tid = uuidv4();
    const bid = uuidv4();

    const execute = () => {
      return publishCommand(robot, 'camera/change/lens', [tid, bid, Date.now(), videoType]);
    };

    return {
      execute,
      topic: `${robot.id}/telemetry/live_lens_change`,
      isMatch: (data) => data.tid === tid && data.bid === bid,
      isSuccess: ({ data }) => data.result === 0,
    };
  };

  const streamingStart = (url, videoId) => (robot) => {
    const tid = uuidv4();
    const bid = uuidv4();

    const execute = () => {
      return publishCommand(robot, 'camera/streaming/start', [tid, bid, Date.now(), url, videoId]);
    };

    return {
      execute,
      topic: `${robot.id}/telemetry/live_start_push`,
      isMatch: (data) => data.tid === tid && data.bid === bid,
      isSuccess: ({ data }) => data.result === 0,
    };
  };

  const streamingStop = (videoId) => (robot) => {
    const tid = uuidv4();
    const bid = uuidv4();

    const execute = () => {
      return publishCommand(robot, 'camera/streaming/stop', [tid, bid, Date.now(), videoId]);
    };

    return {
      execute,
      topic: `${robot.id}/telemetry/live_stop_push`,
      isMatch: (data) => data.tid === tid && data.bid === bid,
      isSuccess: ({ data }) => data.result === 0,
    };
  };

  return {
    changeLens,
    streamingStart,
    streamingStop,
  };
};

export default useVideoCommand;
